module.exports = __webpack_public_path__ + "img/167.3c534537.png";